import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchUser } from 'redux/settings/actions';

import { Checkbox } from 'semantic-ui-react';

import './HideLogoCheckbox.css';

const HideLogoCheckbox = ({
  patchUser,
  me,
}) => {
  const { t } = useTranslation();
  const onCheckboxChange = (_e, { checked }) => {
    const form = new FormData();
    form.append('is_copyright_removed', checked);
    patchUser(form);
  };

  return (
    <div className="hide-logo-checkbox__component">
      <div className="label">
        {t("Hide HeyLink.me Logo")}
      </div>
      <div className="checkbox-wrapper">
        <div className="option">{t("OFF")}</div>
        <Checkbox
          toggle
          checked={me.is_copyright_removed}
          onChange={onCheckboxChange}
        />
        <div className="option">{t("ON")}</div>
      </div>
    </div>
  );
};

HideLogoCheckbox.propTypes = {
  patchUser: PropTypes.func.isRequired,
  me: PropTypes.object,
};

HideLogoCheckbox.defaultProps = {
  me: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {
    patchUser,
  },
)(HideLogoCheckbox);
